import './publicPath' // must stay first: lazy chunks load from the bundle's own server
import './styles.css'
// App.js starts the app itself (createRoot + render, wrapped in ResizeErrorBoundary and Router).
// This file used to call createRoot(...).render(<App />) on the same #root as well, which started a
// second, hidden copy of the whole builder: two 3D engines, the model downloaded twice, every request
// and Heroku ping sent twice. Importing App is enough.
import './App'

// Add Firefox detection and class assignment
if (/FxiOS/i.test(navigator.userAgent)) {
  document.documentElement.classList.add('firefox-ios')
}
